import React from "react"
import {LoggedInTooltipProps, usernameTestid} from "./props"
import {Username} from "./component"

const MyAccountLoggedInTooltipUsername = ({notText, firstName}: LoggedInTooltipProps) => {
    return <Username data-testid={usernameTestid} data-dtrum-replay-mask="">{`${notText} ${firstName}?`}</Username>
}

export default MyAccountLoggedInTooltipUsername
